module.exports = __webpack_public_path__ + "static/47-6590667f3120ee4c0cfbcbf7b9c65baf.png";